import { render, staticRenderFns } from "./AdminUserDetail.vue?vue&type=template&id=f561b39c&scoped=true"
import script from "./AdminUserDetail.vue?vue&type=script&lang=js"
export * from "./AdminUserDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561b39c",
  null
  
)

export default component.exports